import * as React from 'react'

import { Actions, Footer, StyledButton } from './styles'

export type ModalFooterProps = {
  /** The price summary, or anything else that sits above the buttons. */
  children?: React.ReactNode
  primaryLabel: string
  onPrimary(): void
  primaryDisabled?: boolean
  /** The quieter button beside it — "reset" in an editor, nothing on the option list. */
  secondaryLabel?: string
  onSecondary?: () => void
  /** Pinned to the bottom of the scrolling panel? */
  sticky?: boolean
}

export const ModalFooter: React.FC<ModalFooterProps> = ({
  children,
  primaryLabel,
  onPrimary,
  primaryDisabled,
  secondaryLabel,
  onSecondary,
  sticky = true,
}) => (
  <Footer $sticky={sticky}>
    {children}

    <Actions>
      <StyledButton type='button' onClick={onPrimary} aria-disabled={primaryDisabled}>
        {primaryLabel}
      </StyledButton>
      {secondaryLabel !== undefined && onSecondary !== undefined && (
        <StyledButton type='button' variant='ghost' onClick={onSecondary}>
          {secondaryLabel}
        </StyledButton>
      )}
    </Actions>
  </Footer>
)
